<template>
  <div
    class="page-layout"
    v-if="store.interfaceVisible"
  >
    <div class="imperso">
      <BasicText
        size="h4"
        color="secondary-900"
      >
        Se connecter en tant que
      </BasicText>
      <WrapperAutocomplete
        label="Utilisateur adhérent ou prestataire AKTO"
        hint="Nom ou email d'un utilsateur adhérent ou prestataire AKTO"
        placeholder="utilisateur.externe@email.com"
        style="flex: 1"
        v-model="impersonnalisation"
        :search="store.searchImpersonnalisation"
        key-id="userId"
        key-label="email"
        :search-min-length="3"
      >
        <template v-slot="{ email, nom, prenom }">
          <div class="slot">
            <BasicText weight="bold">{{ prenom }} {{ nom }}</BasicText>
            <BasicText>{{ email }}</BasicText>
          </div>
        </template>
      </WrapperAutocomplete>
      <div class="bottom">
        <BasicButton
          @click="store.abandonnerImpersonnalisationAsync"
          label="Abandonner"
          type="danger"
          icon-name="close-square"
        />
        <BasicButton
          :disabled="validerDisabled"
          @click="validerImperso"
          label="Se connecter"
          icon-name="profile"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount } from 'vue'
  import { useImpersonalisationStore } from '../useImpersonnalisationStore'
  import {
    PREFERENCES_IMPERSONNALISATION,
    type ImpersonnalisationResult,
  } from '@/features/auth/authentification/modeles/IImpersonnalisationProvider'
  import { storeToRefs } from 'pinia'
  import { usePreferencesUtilisateur } from '@/features/application/preferences'

  const { getPreferencesAsync, setPreferencesAsync } =
    usePreferencesUtilisateur<ImpersonnalisationResult>(PREFERENCES_IMPERSONNALISATION)
  const store = useImpersonalisationStore()
  const { impersonnalisation } = storeToRefs(store)

  const validerImperso = async () => {
    await setPreferencesAsync(impersonnalisation.value)
    await store.validerImpersonnalisationAsync()
  }

  onBeforeMount(async () => {
    if (!impersonnalisation.value) {
      impersonnalisation.value = await getPreferencesAsync()
    }
  })

  const validerDisabled = computed(() => {
    return !impersonnalisation.value?.userId
  })
</script>

<style scoped>
  .page-layout {
    display: grid;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-template-rows: 80vh;
  }
  .imperso {
    display: flex;
    flex-direction: column;
    gap: 32px;
    background-color: white;
    padding: 28px 48px;
    border-radius: 24px;
  }

  .imperso .bottom {
    display: flex;
    align-items: flex-end;
    gap: 32px;
    padding: 12px 1px 0 1px;
  }

  .slot {
    display: flex;
    flex-direction: column;
  }
</style>
